import React from "react";
import { ClipLoader } from "react-spinners";
import { Container } from "./BCRSuspenseStyles";
const BCRSuspense = () => {
    return (React.createElement(Container, null,
        React.createElement(ClipLoader, null)));
};
export default BCRSuspense;
//# sourceMappingURL=BCRSuspense.js.map